import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import backBtn from "../../assets/icons/UpdatedCheckoutPage/backBtn.svg";
import AlphaTraderIcon from "../../assets/icons/AlphaTrader.svg";
import googlepay from "../../assets/PaymentIcons/Google_Pay_Logo.svg";
import "./UpdatedCheckoutPage.scss";
import step1 from "../../assets/icons/UpdatedCheckoutPage/Step1.svg";
import step1Active from "../../assets/icons/UpdatedCheckoutPage/Step1Active.svg";
import step2 from "../../assets/icons/UpdatedCheckoutPage/Step2.svg";
import step2Active from "../../assets/icons/UpdatedCheckoutPage/Step2Active.svg";
import step3 from "../../assets/icons/UpdatedCheckoutPage/Step3.svg";
import step3Active from "../../assets/icons/UpdatedCheckoutPage/Step3Active.svg";
import stepInstant from "../../assets/icons/UpdatedCheckoutPage/StepInstant.svg";
import stepInstantActive from "../../assets/icons/UpdatedCheckoutPage/StepInstantActive.svg";
import CheckCircle from "../../assets/icons/UpdatedCheckoutPage/CheckCircle.svg";
import BlankCircle from "../../assets/icons/UpdatedCheckoutPage/BlankCircle.svg";
import MT5 from "../../assets/icons/UpdatedCheckoutPage/MT5.svg";
import Ctrader from "../../assets/icons/UpdatedCheckoutPage/CTrader.svg";
import Dxtrade from "../../assets/icons/UpdatedCheckoutPage/DXTrader.svg";
import TraderLocker from "../../assets/icons/UpdatedCheckoutPage/TradeLocker.svg";
import {
  getChallenges,
  getUserBasicDetails,
} from "../../store/reducers/paymentReducer";
import {
  getUserProfile,
  LoadUser,
  sessionTimeout,
  addCurrentAccount,
} from "../../store/reducers/userProfileReducer";

import { dollarUS } from "../../utilities/formatters";
import { axiosInstance, baseUrl } from "../../Axios";

import radioActiveBtn from "../../assets/icons/UpdatedCheckoutPage/radioActiveBtn.svg";
import radioBtn from "../../assets/icons/UpdatedCheckoutPage/radioBtn.svg";
import zoomImg from "../../assets/icons/UpdatedCheckoutPage/zoomBtn.svg";
import greenDot from "../../assets/icons/UpdatedCheckoutPage/greenDot.svg";
import Logo from "../../assets/images/SignupImg/Logo.svg";
import PDFDoc from "../../assets/Docs/Alpha Capital Group - Terms and Conditions.pdf";
import {
  addGoogleTagScripts,
  addMetaScripts,
  // challenges,
  checkValidate,
  countries,
  CustomerInfoForm,
  CustomerInformation,
  handleApplyCoupon,
  paymentMethodDetails,
  paymentMethods,
  payout_type,
  PayoutTypeSelector,
  platformList,
  stripePaymentInitV4,
  freeTrialPaymentInitV4,
  TncModal,
  findChallengeByIdentifier,
} from "./PaymentExports";
import { AcctokenD, login, RefftokenD } from "../../store/actions";
import CombinedPopup from "../../components/Popups/CombinedPopup";
import ErrorModal from "../../reusableComponents/ErrorModal";
import axios from "axios";
import { DataPreviewModal } from "./PreviewModal";
import { UpiIdModal } from "./UpiIdModal";
import { PAYOK_ALLOWED_COUNTRIES } from "../../constants/payments";
import { message, Modal } from "antd";
import PDFPreview from "../../reusableComponents/PDFReview/PDFReview";

const UpdatedNewCheckoutPage = ({ publicCheckout = false }) => {
  const { challenge_id, coupon_code, challenge_name } = useParams();
  const challenges = useSelector((state) => state.payments.challenges || []); // Default to empty array
  const idToken = useSelector((state) => state.ACCtoken);
  const refresh_token = useSelector((state) => state.REFFtoken);
  const [selectedStep, setSelectedStep] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [selectedChallenge, setSelectedChallenge] = useState(null);
  const [selectedPlatform, setSelectedPlatform] = useState(null);
  const [selectedPayoutType, setSelectedPayoutType] = useState(2);
  const [selectedProfitSplit, setSelectedProfitSplit] = useState(80);
  const [selectedAcType, setSelectedAcType] = useState(1); // Index of selected account type
  const [useEA, setUseEA] = useState(false); // Boolean for EA use
  const [isOpen, setIsOpen] = useState(true);
  const [showObjectives, setShowObjectives] = useState(false);
  const ac_type = ["Raw spread", "Standard spread"];
  const [selectedAddons, setSelectedAddons] = useState([]);

  const addonsList = [
    { name: "90% Profit Share", value: "90" },
    { name: "Swap-Free Account", value: "swap_free" },
    // { name: "Extra Account Reset", value: "extra_reset" },
    // { name: "Weekend Holding", value: "weekend_holding" },
  ];

  const handleAddonToggle = (value) => {
    if (value === "swap_free" && selectedPlatform?.value !== "mt5") {
      return;
    }
    if (value === "90") {
      setSelectedProfitSplit((prev) => (prev === 90 ? 80 : 90));
    } else {
      const isAdding = !selectedAddons.includes(value);
      if (value === "swap_free" && isAdding) {
        setSelectedAcType(1);
        // When swap_free is unselected, spread type can be freely changed (no automatic reset)
      }
      setSelectedAddons((prev) =>
        isAdding ? [...prev, value] : prev.filter((item) => item !== value),
      );
    }
  };

  const [selectedChallenge_id, setSelectedChallenge_id] =
    useState(challenge_id);
  const navigate = useNavigate();
  useEffect(() => {
    const identifier = challenge_name || challenge_id;
    if (!identifier || !Array.isArray(challenges)) return;

    const result = findChallengeByIdentifier(challenges, identifier);

    if (result) {
      const {
        challenge: matchingChallenge,
        plan: matchingPlan,
        step: matchingStep,
      } = result;
      setSelectedChallenge_id(matchingChallenge.id);
      setSelectedChallenge(matchingChallenge);
      setSelectedStep(matchingStep);
      setSelectedPlan(matchingPlan);
    } else {
      console.warn(`No challenge found for identifier: ${identifier}`);
    }
  }, [challenges, challenge_id, challenge_name]);

  // Reset selectedPlan and selectedChallenge when selectedStep changes
  useEffect(() => {
    if (
      selectedStep &&
      (!selectedPlan || !selectedStep.plans.includes(selectedPlan))
    ) {
      setSelectedPlan(selectedStep.plans?.[0] || null);
    }
  }, [selectedStep]);

  useEffect(() => {
    if (
      selectedPlan &&
      (!selectedChallenge ||
        !selectedPlan.challenges.includes(selectedChallenge))
    ) {
      setSelectedChallenge(selectedPlan.challenges?.[0] || null);
      setSelectedChallenge_id(selectedPlan.challenges?.[0]?.id || null);
      // setSelectedPayoutType(selectedPlan.challenges?.[0]?.payout_type);
    }
  }, [selectedPlan]);

  // platform

  // Example state (adjust as needed)
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
  const [selectedCrypto, setSelectedCrypto] = useState(null);
  const radioGroupRef = useRef(null);

  // Payok UPI/Personal ID collection
  const [showUpiModal, setShowUpiModal] = useState(false);
  const [upiId, setUpiId] = useState("");
  const [upiConfirmed, setUpiConfirmed] = useState(false);
  const [pendingPreviewAfterUpi, setPendingPreviewAfterUpi] = useState(false);

  useEffect(() => {
    if (selectedPaymentMethod !== "payok") {
      setUpiId("");
      setUpiConfirmed(false);
    }
  }, [selectedPaymentMethod]);

  const [countryCheck, setCountryCheck] = useState(""); // Examplezz\
  // Example variables (replace with your actual logic)
  const countryCheckingReq = async () => {
    try {
      let url = `check/country/`;
      const { data, status } = await axiosInstance.get(url);
      if (status < 399) {
        const country = data?.country;

        setSelectedPaymentMethod("nuvei");
        setCountryCheck(country);
        setSelectedCrypto(null);

        // Set default platform based on country
        if (country === "US") {
          // For US, default to ctrader
          const ctraderPlatform = platformList.find(
            (p) => p.value === "ctrader",
          );
          setSelectedPlatform(ctraderPlatform || platformList[0]);
        } else {
          // For other countries, default to MT5 (first in list)
          setSelectedPlatform(platformList[0]);
        }
      }
    } catch (error) {
      console.log(error.response?.data || error.message);
      // throw error.response?.data || error.message;
    }
  };
  useEffect(() => {
    countryCheckingReq();
  }, []);

  // Reset EA setting when platform is changed to non-MT5
  useEffect(() => {
    if (selectedPlatform?.value && selectedPlatform.value !== "mt5") {
      setUseEA(false);
      setSelectedAddons((prev) => prev.filter((item) => item !== "swap_free"));
    }
  }, [selectedPlatform?.value]);

  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [confirmPaymentClick, setConfirmPaymentClick] = useState(false);
  const [basicDetailsDisabled, setBasicDetailsDisabled] = useState({});
  const [basicDetails, setBasicDetails] = useState({
    first_name: "",
    last_name: "",
    email: "",
    contact: "",
    Country: "",
    City: "",
    country_code: "",
    confirmEmail: "",
  });
  const [countryCode, setCountryCode] = useState(null);

  const anonymous = false;

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);

      try {
        // Fetch challenges
        const challengesRes = await dispatch(getChallenges());
        // Add logic here if you need to use challengesRes

        if (!anonymous && !publicCheckout) {
          // Fetch user details
          const userRes = await dispatch(getUserBasicDetails());
          const updatedDetails = {
            ...userRes,
            contact: userRes?.Contact_number,
          };
          setBasicDetails(updatedDetails);
          setBasicDetailsDisabled({
            first_name: userRes?.first_name && true,
            last_name: userRes?.last_name && true,
            email: userRes?.email && true,
            contact: userRes?.Contact_number && true,
            Country:
              countries.find((item) => item.label === userRes?.Country) && true,
            City: userRes?.City && true,
            country_code: userRes?.country_code && true,
          });

          // Find country
          const countryString = String(userRes.country_code).toLowerCase();
          const country = countries.find(
            (item) =>
              item.label.toLowerCase() === countryString ||
              item.phone.toLowerCase() === countryString,
          );
          if (country) setCountryCode(country);

          // Load user
          await dispatch(LoadUser());
        }

        // Add scripts
        addGoogleTagScripts();
        addMetaScripts();
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [dispatch]);

  const [finalPrice, setFinalPrice] = useState({});
  const [isCheckedError, setIsCheckedError] = useState("");
  const [isChecked, setIsChecked] = React.useState({
    tnc: false,
    not_us_resident: false,
    acknowledge_personal_data: false,
    agree_to_news_letters: false,
  });
  const [coupon, setCoupon] = useState({
    value: coupon_code || null,
    error: false,
  });
  const [prevChallengeId, setPrevChallengeId] = useState(selectedChallenge_id);
  const [prevCouponCode, setPrevCouponCode] = useState(coupon_code);

  if (selectedChallenge_id !== prevChallengeId || coupon_code !== prevCouponCode) {
    setPrevChallengeId(selectedChallenge_id);
    setPrevCouponCode(coupon_code);
    setCoupon({
      value: coupon_code || null,
      error: false,
    });
  }
  const [isCouponLoading, setIsCouponLoading] = useState(false);
  const prevPayoutTypeRef = useRef(selectedPayoutType);
  const prevChallengeIdRef = useRef(selectedChallenge_id);
  const applyCoupon = useCallback(
    async (selectedPayoutType, passedCoupon, profitSplit) => {
      try {
        setIsCouponLoading(true);
        const result = await handleApplyCoupon(
          { value: passedCoupon ?? coupon.value }, // No 'error' field needed here!
          selectedPayoutType,
          selectedChallenge_id,
          idToken,
          setFinalPrice,
          // FIX: correctly update only error, preserving other properties!
          (error) => setCoupon((prev) => ({ ...prev, error })),
          publicCheckout,
          selectedPlatform?.value,
          profitSplit,
          selectedAddons.includes("swap_free")
        );
        console.log("Coupon applied successfully:", result);
      } catch (err) {
        console.log("Error applying coupon:", err);
      } finally {
        setIsCouponLoading(false);
      }
    },
    [
      coupon,
      selectedStep?.step,
      selectedChallenge_id,
      idToken,
      publicCheckout,
      selectedPlan,
      selectedPlatform?.value,
      selectedAddons,
    ],
  );

  const showProfitSplit =
    selectedStep?.step === "Step 1" ||
    selectedStep?.step === 1 ||
    ((selectedStep?.step === "Step 2" || selectedStep?.step === 2) &&
      selectedPlan?.plan_type?.toLowerCase().includes("alpha pro") &&
      selectedPayoutType === 2) ||
    ((selectedStep?.step === "Step 3" || selectedStep?.step === 3) &&
      selectedPayoutType === 2);

  // Add a ref to track if coupon was already applied
  const hasAppliedCoupon = useRef(false);

  const stepOneChallenges =
    challenges
      .find((item) => item.step === 1)
      ?.plans.find((plan) => plan.plan_type === "Alpha One")
      ?.challenges.map((challenge) => challenge.id) || [];

  const isNotStepOne = !stepOneChallenges.includes(selectedChallenge_id);

  // Reset hasAppliedCoupon when challenge ID, selectedPayoutType, profitSplit, account type, or addons change
  useEffect(() => {
    hasAppliedCoupon.current = false;
  }, [
    selectedChallenge_id,
    selectedPayoutType,
    isNotStepOne,
    selectedProfitSplit,
    selectedAcType,
    selectedAddons,
  ]);

  useEffect(() => {
    // Only run if coupon hasn't been applied yet and it's not a step one challenge
    const planTypeLower = selectedPlan?.plan_type?.toLowerCase() || "";
    const isAlphaProOrThree = planTypeLower.includes("alpha pro") || planTypeLower.includes("alpha three");
    if (
      isAlphaProOrThree &&
      !hasAppliedCoupon.current &&
      isNotStepOne
    ) {
      applyCoupon(
        selectedPayoutType,
        null,
        showProfitSplit ? selectedProfitSplit : null,
      );
      hasAppliedCoupon.current = true; // Mark as applied
    }
  }, [
    selectedPlan?.plan_type,
    selectedPayoutType,
    selectedChallenge_id,
    isNotStepOne,
    applyCoupon,
    selectedProfitSplit,
    showProfitSplit,
    selectedAddons,
  ]);
  useEffect(() => {
    if (coupon.value === "")
      applyCoupon(
        selectedPayoutType,
        null,
        showProfitSplit ? selectedProfitSplit : null,
      );
  }, [coupon.value, showProfitSplit, selectedProfitSplit, selectedAddons]);

  useEffect(() => {
    if (selectedPlatform?.value !== "mt5") {
      setUseEA(false);
      setSelectedAddons((prev) => prev.filter((item) => item !== "swap_free"));
    }
  }, [selectedPlatform?.value]);

  useEffect(() => {
    const planType = selectedPlan?.plan_type?.toLowerCase();
    if (
      planType === "swing" ||
      planType === "alpha direct" ||
      planType === "free trial"
    ) {
      setSelectedAddons((prev) => prev.filter((item) => item !== "swap_free"));
    }
  }, [selectedPlan?.plan_type]);

  // Call get-final-price API when account type, account size, profit split, or addons change
  useEffect(() => {
    if (!selectedChallenge_id || !selectedPlan) return;
    // Skip if already called by the Alpha Pro / Alpha Three effect above for this same change
    if (hasAppliedCoupon.current) return;
    applyCoupon(
      selectedPayoutType,
      coupon.value || null,
      showProfitSplit ? selectedProfitSplit : null,
    );
    hasAppliedCoupon.current = true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAcType, selectedChallenge_id, selectedProfitSplit, selectedAddons]);

  const handleCouponClick = () => {
    applyCoupon(
      selectedPayoutType,
      null,
      showProfitSplit ? selectedProfitSplit : null,
    );
    hasAppliedCoupon.current = true; // Mark as applied when clicked
  };

  // Reset hasAppliedCoupon when plan changes
  useEffect(() => {
    hasAppliedCoupon.current = false;
  }, [selectedPlan?.plan_type]);

  const payload = {
    refresh_token: refresh_token,
    payment_method: selectedPaymentMethod,
    challenge_id: selectedChallenge_id,
    coupon: coupon?.value,
    email: basicDetails?.email,
    confirmEmail: basicDetails?.email,
    first_name: basicDetails?.first_name,
    last_name: basicDetails?.last_name,
    contact: basicDetails?.contact,
    // payout_type: selectedStep?.step !== "Step 1" ? selectedPayoutType : 2,
    payout_type:
      selectedPlan?.plan_type?.toLowerCase() === "swing"
        ? 2
        : selectedStep?.step !== "Step 1"
          ? selectedPayoutType
          : 2,
    cryptocurrency: selectedCrypto,
    country_code: countryCode?.code,
    raw_spread: selectedAcType === 0 ? true : null,
    platform: selectedPlatform?.value,
    EAs: useEA ? true : null,
    swap_free: selectedAddons.includes("swap_free"),
    ...(showProfitSplit && { profit_split: selectedProfitSplit }),
    ...(selectedPaymentMethod === "payok" && { personal_id: upiId }),
  };
  console.log(
    selectedPlan?.plan_type,
    "selectedPlan?.plan_typeselectedPlan?.plan_type",
  );
  const [allErrors, setAllErrors] = useState({});
  const [isError, setIsError] = useState();
  const [previewData, setPreviewData] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const accountPreview = async () => {
    if (!selectedPlatform) {
      message.error("Please select a platform.");
      return;
    }

    if (!selectedPaymentMethod && selectedPlan?.plan_type !== "Free Trial") {
      message.error("Please select a payment method.");
      return;
    }

    if (selectedPaymentMethod === "payok" && !upiConfirmed) {
      setShowUpiModal(true);
      return;
    }

    const checkAllTrue = () => {
      const requiredKeys = [
        "tnc",
        ...(countryCheck !== "US" &&
          selectedPlatform?.value !== "dxtrade" &&
          selectedPlatform?.value !== "tradelocker" &&
          selectedPlatform?.value !== "ctrader"
          ? ["not_us_resident"]
          : []),
        "acknowledge_personal_data",
      ];
      return requiredKeys.every((key) => isChecked[key] === true);
    };
    // Validate basic details
    const validationResult = checkValidate(basicDetails, publicCheckout);
    if (!validationResult?.isValid) {
      setAllErrors(
        validationResult?.errors || { general: "Validation failed" },
      );
      return;
    }

    // Check terms and conditions
    if (!checkAllTrue()) {
      setIsCheckedError("Please accept all required terms and conditions.");
      return;
    }

    try {
      setConfirmPaymentClick(true);

      const accountPreview = await axios.post(
        `${baseUrl}/payment/account-preview/`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${idToken}`,
          },
        },
      );
      if (accountPreview.status === 200) {
        setPreviewData(accountPreview?.data);
        setIsModalVisible(true);
      } else {
        message.error("Failed to fetch account preview. Please try again.");
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        message.error(
          error.response?.data?.message ||
          "Failed to fetch account preview. Server error occurred.",
        );
      } else {
        message.error("An unexpected error occurred. Please try again.");
      }

      console.error("Account preview error:", error);
    } finally {
      setConfirmPaymentClick(false);
    }
  };

  useEffect(() => {
    if (pendingPreviewAfterUpi && upiConfirmed) {
      setPendingPreviewAfterUpi(false);
      accountPreview();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pendingPreviewAfterUpi, upiConfirmed]);

  const handleUpiProceed = (value) => {
    setUpiId(value);
    setUpiConfirmed(true);
    setShowUpiModal(false);
    setPendingPreviewAfterUpi(true);
  };

  const handleUpiCancel = () => {
    setShowUpiModal(false);
  };

  const handleFinalCheckout = async () => {
    try {
      setConfirmPaymentClick(true);
      // Update user profile only if not public checkout
      if (!publicCheckout) {
        const profilePayload = {
          first_name: basicDetails.first_name,
          last_name: basicDetails.last_name,
          Contact_number: basicDetails.contact,
          Country: basicDetails.Country,
          City: basicDetails.City,
          country_code: basicDetails?.country_code
            ? Number(String(basicDetails.country_code).replace("-", ""))
            : null,
        };

        await axios
          .post(`${baseUrl}/v2/user/profile/create/`, profilePayload, {
            headers: {
              Authorization: `Bearer ${idToken}`,
            },
          })
          .catch((error) => {
            if (
              error.response?.status === 400 &&
              error.response?.data?.Contact_number
            ) {
              // Handle duplicate phone number error
              setBasicDetails((prev) => ({
                ...prev,
                contactError:
                  error.response.data.Contact_number[0] ||
                  "This phone number is already in use.",
              }));
              setConfirmPaymentClick(false);
              // Scroll to the contact field for better UX
              document
                .getElementById("contact-input")
                ?.scrollIntoView({ behavior: "smooth" });
              throw new Error("Phone number already in use");
            }
            throw error; // Re-throw other errors
          });
      }

      // Handle free trial case
      if (selectedPlan?.plan_type === "Free Trial") {
        const freeTrialPayload = {
          challenge: selectedChallenge_id,
          raw_spread: selectedAcType === 0,
          platform: selectedPlatform?.value,
          EAs: useEA,
          email: basicDetails?.email,
        };

        const response = await freeTrialPaymentInitV4(
          dispatch,
          freeTrialPayload,
          idToken,
          publicCheckout,
        );

        if (response?.data?.success) {
          if (response.auth) {
            dispatch(AcctokenD(response.auth.idToken));
            dispatch(RefftokenD(response.auth.refresh_token));
            dispatch(sessionTimeout(false));
            await dispatch(getUserProfile());
            dispatch(login());
          }
          dispatch(addCurrentAccount({ login_id: response.data.login }));
          navigate("/AccountMetric");
        } else {
          throw new Error("Failed to create free trial account");
        }
        return;
      }

      // Process payment for non-free trial cases

      // Process payment
      const response = await stripePaymentInitV4(
        dispatch,
        payload,
        idToken,
        publicCheckout,
      );

      if (!response) {
        throw new Error("No response received from payment service");
      }

      // Handle authentication
      if (response.auth) {
        try {
          dispatch(AcctokenD(response.auth.idToken));
          dispatch(RefftokenD(response.auth.refresh_token));
          dispatch(sessionTimeout(false));

          await dispatch(getUserProfile());
          dispatch(login());
        } catch (authError) {
          console.error("Authentication processing error:", authError);
          setIsError("Authentication failed. Please try again.");
          return;
        } finally {
          setConfirmPaymentClick(false);
        }
      }

      // Handle redirect
      if (response?.url) {
        window.location.href = response.url;
      } else {
        console.warn("No redirect URL provided in response");
      }
    } catch (error) {
      // Determine specific error message
      let errorMessage = "An unexpected error occurred during checkout.";
      if (error.message?.includes("payment")) {
        errorMessage = "Payment processing failed. Please try again.";
      } else if (error.message?.includes("network")) {
        errorMessage = "Network error. Please check your connection.";
      } else {
        errorMessage = error?.message || error?.detail || error[0];
      }

      setIsError(errorMessage);
    } finally {
      setConfirmPaymentClick(false);
    }
  };

  const [showTnc, setShowTnc] = useState(false);

  const [scale, setScale] = useState(1);

  useEffect(() => {
    const updateScale = () => {
      const screenWidth = window.innerWidth;
      setScale(screenWidth < 750 ? 0.5 : 1);
    };

    updateScale(); // Set on initial load
    window.addEventListener("resize", updateScale);

    return () => window.removeEventListener("resize", updateScale);
  }, []);
  useEffect(() => {
    if (
      coupon_code &&
      !hasAppliedCoupon.current &&
      selectedChallenge_id &&
      selectedPlan &&
      selectedPayoutType !== undefined
    ) {
      setTimeout(() => {
        // Pass coupon_code directly to applyCoupon
        applyCoupon(
          selectedPayoutType,
          coupon_code,
          showProfitSplit ? selectedProfitSplit : null,
        );
        hasAppliedCoupon.current = true;
        setCoupon((pre) => ({ ...pre, value: coupon_code }));
      }, 0);
    }
    // eslint-disable-next-line
  }, [coupon_code, selectedChallenge_id, selectedPlan, selectedPayoutType]);
  useEffect(() => {
    console.log(coupon, "actual_priceactual_price");
  }, [coupon]);

  // 1. Add state for Crypto Confirmation Modal
  const [showCryptoModal, setShowCryptoModal] = useState(false);

  // 2. Modify handlePaymentMethod
  const handlePaymentMethod = (method) => {
    if (method === "coinspayment") {
      // If user selects crypto, show the warning modal first
      setShowCryptoModal(true);
    } else {
      // Otherwise set the method immediately
      setSelectedPaymentMethod(method);
    }
  };

  // 3. Handle Confirm (User clicks OK)
  const handleCryptoConfirm = () => {
    setSelectedPaymentMethod("coinspayment");
    setShowCryptoModal(false);
  };

  // 4. Handle Cancel (User clicks Cancel)
  const handleCryptoCancel = () => {
    setShowCryptoModal(false);

    // Logic to revert to the first valid payment method
    const firstMethod = "nuvei";

    // Only switch if we aren't already on a valid method (optional, but ensures "back to first" behavior)
    if (selectedPaymentMethod !== firstMethod) {
      setSelectedPaymentMethod(firstMethod);
    }
  };

  const stepsImages = {
    1: { normal: step1, active: step1Active },
    2: { normal: step2, active: step2Active },
    3: { normal: step3, active: step3Active },
    "Instant Funding": { normal: stepInstant, active: stepInstantActive },
  };

  const platformIcons = {
    mt5: MT5,
    dxtrade: Dxtrade,
    ctrader: Ctrader,
    tradelocker: TraderLocker,
  };

  const getPlanChallenge = (plan) => {
    if (!plan || !plan.challenges || plan.challenges.length === 0) return null;
    const currentSize = selectedChallenge?.account_balance;

    const match = plan.challenges.find(
      (c) => c.account_balance === currentSize,
    );
    return match || plan.challenges[0];
  };

  const renderPlanDetails = (plan) => {
    const challenge = getPlanChallenge(plan);
    if (!challenge) return null;

    const account_balance = parseFloat(challenge.account_balance);

    const calculatePercentage = (value) => {
      if (!account_balance || !value) return "-";
      const percentage = (parseFloat(value) / account_balance) * 100;
      // Remove .00 if it's a whole number
      return `${percentage % 1 === 0 ? percentage.toFixed(0) : percentage.toFixed(2)}%`;
    };

    const formatDollar = (value) => {
      if (!value) return "$0";
      const valNum = parseFloat(value);
      if (valNum >= 1000) {
        return `$${Math.floor(valNum / 1000)}k`;
      }
      return `$${valNum.toLocaleString("en-US")}`;
    };

    // 1. Leverage
    const leverageValue = challenge.Leverage ? `1:${challenge.Leverage}` : "-";

    // 2. Profit Target 1
    const profitTarget1Value = calculatePercentage(challenge.Evaluation_Phase_1);

    // 3. Profit Target 2
    const showProfitTarget2 =
      parseFloat(challenge.Evaluation_Phase_2) > 0 &&
      !plan.plan_type?.toLowerCase().includes("free trial");
    const profitTarget2Value = calculatePercentage(challenge.Evaluation_Phase_2);

    // 4. Profit Target 3
    const showProfitTarget3 = parseFloat(challenge.Evaluation_Phase_3) > 0;
    const profitTarget3Value = calculatePercentage(
      challenge.Evaluation_Phase_3,
    );

    // 5. Max Loss / Trailing Max Loss
    let maxLossLabel = "Max Loss";
    let maxLossValue = "-";
    if (plan.plan_type.includes("Alpha One") && challenge.trailing_mll !== 0) {
      maxLossLabel = "Trailing Max Loss";
      maxLossValue = `${challenge.trailing_mll}%`;
    } else {
      maxLossValue = calculatePercentage(challenge.Max_Loss);
    }

    // 6. Max Daily Loss
    const maxDailyLossValue = calculatePercentage(challenge.Max_Daily_Loss);
    const planTypeLower = plan.plan_type?.toLowerCase() || "";
    const isAlphaOneThreePercent =
      (planTypeLower.includes("alpha one")) &&
      parseFloat(maxDailyLossValue) === 3;

    // 7. Profit Split
    const profitSplitValue =
      plan?.plan_type === selectedPlan?.plan_type && showProfitSplit && selectedProfitSplit
        ? `${selectedProfitSplit}%`
        : challenge.Profit_Split === "N/A"
          ? "-"
          : challenge.Profit_Split
            ? `${challenge.Profit_Split}%`
            : "-";

    const isSwingOrAlphaOne =
      plan.plan_type?.toLowerCase().includes("swing") ||
      plan.plan_type?.toLowerCase().includes("alpha one");
    const isAlphaDirect = plan.plan_type === "Alpha Direct";

    // 8. Payout Type (On Demand or Bi-Weekly)
    const payoutLabel = isAlphaDirect
      ? "Payout type"
      : isSwingOrAlphaOne
        ? "On-Demand Payout"
        : selectedPayoutType === 1
          ? "Bi Weekly Payout"
          : "On-Demand Payout";
    const payoutValue = plan.plan_type?.toLowerCase().includes("free trial")
      ? ""
      : isAlphaDirect
        ? "15% Consistency + 1% minimum profit"
        : isSwingOrAlphaOne
          ? "Yes"
          : challenge.Bi_Weekly_Profit_Split
            ? "Yes"
            : "No";

    // 9. Max Capital Growth (hidden for Instant Qualified, Step 1, and Free Trial)
    const isAlphaProOrSwing = plan.plan_type?.toLowerCase().includes("alpha pro") ||
      plan.plan_type?.toLowerCase().includes("swing");
    const maxCapitalGrowthValue = isAlphaProOrSwing ? 'Up to $2M' : formatDollar(challenge.Max_Capital_Growth);
    const stepNumber = Number(selectedStep?.step?.replace(/\D/g, ""));
    const isInstantStep = selectedStep?.step?.toLowerCase().includes("instant");
    const isFreeTrialPlan = plan.plan_type?.toLowerCase().includes("free trial");
    const showMaxCapitalGrowth = !isInstantStep && stepNumber !== 1 && !isFreeTrialPlan;

    return (
      <div className="plan_details_panel">
        <div className="plan_details_row">
          <span className="row_label">Leverage</span>
          <span className="row_value">up to {leverageValue}</span>
        </div>
        {plan.plan_type !== "Alpha Direct" && (
          <div className="plan_details_row">
            <span className="row_label">{`Profit Target ${plan.plan_type !== "Alpha One" ? 1 : ""}`}</span>
            <span className="row_value">{profitTarget1Value}</span>
          </div>
        )}
        {showProfitTarget2 && (
          <div className="plan_details_row">
            <span className="row_label">Profit Target 2</span>
            <span className="row_value">{profitTarget2Value}</span>
          </div>
        )}
        {showProfitTarget3 && (
          <div className="plan_details_row">
            <span className="row_label">Profit Target 3</span>
            <span className="row_value">{profitTarget3Value}</span>
          </div>
        )}
        <div className="plan_details_row">
          <span className="row_label">{maxLossLabel}</span>
          <span className="row_value">{maxLossValue}</span>
        </div>
          <div className="plan_details_row">
            <span className="row_label">Max Daily Loss</span>
            <span className="row_value">{maxDailyLossValue}</span>
          </div>
        <div className="plan_details_row">
          <span className="row_label">Profit Split</span>
          <span className="row_value">{profitSplitValue}</span>
        </div>
        {!plan.plan_type?.toLowerCase().includes("free trial") && (
          <div className="plan_details_row">
            <span className="row_label">{payoutLabel}</span>
            <span className="row_value">{payoutValue}</span>
          </div>
        )}
        {showMaxCapitalGrowth && (
          <div className="plan_details_row">
            <span className="row_label">Max Capital Growth</span>
            <span className="row_value">{maxCapitalGrowthValue}</span>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="UpdatedCheckoutPage_main">
      <Modal
        title="Crypto Payment Warning"
        open={showCryptoModal}
        onOk={handleCryptoConfirm}
        onCancel={handleCryptoCancel}
        okText="Proceed"
        cancelText="Cancel"
        centered
        okButtonProps={{ danger: true }} // Optional: makes the proceed button red to indicate caution
        style={{
          maxWidth: "600px",
          backgroundColor:
            "var(--Box-BG, linear-gradient(103deg, rgba(184, 230, 255, 0.03) 0%, rgba(184, 230, 255, 0.07) 100%))",
        }}
      >
        <p style={{ fontSize: "16px", lineHeight: "1.5", color: "white" }}>
          <p>You are proceeding with a cryptocurrency payment.</p>{" "}
          <p>
            Please ensure that the correct coin,{" "}
            <strong>ETH, USDC, or USDT</strong>, is sent on the correct network,{" "}
            <strong>ERC20 (Ethereum network) or TRC20 (TRON network).</strong>
          </p>
          Sending the wrong coin or using the wrong network will result in the
          automation not working and your account not being delivered, and funds
          may also be lost. <strong>Please proceed with caution.</strong>
        </p>
      </Modal>
      <DataPreviewModal
        data={previewData || {}}
        isModalVisible={isModalVisible}
        setIsModalVisible={setIsModalVisible}
        onConfirm={handleFinalCheckout}
      />
      <UpiIdModal
        open={showUpiModal}
        onClose={handleUpiCancel}
        onProceed={handleUpiProceed}
        country={basicDetails.Country}
      />
      {isError && (
        <ErrorModal
          setModalOpen={setIsError}
          btnText={"close"}
          desc={isError}
        />
      )}
      <div className="UpdatedCheckoutPage_main_logo">
        <img src={Logo} alt="Logo" />
      </div>
      {!publicCheckout && (
        <div
          style={{ cursor: "pointer" }}
          className="backBtnContainer"
          onClick={() => navigate("/dashboard")}
        >
          <img style={{ width: "20px" }} src={backBtn} alt="backBtn" />
          Back
        </div>
      )}
      <div className="UpdatedCheckoutPage_left_right_sec">
        <div className="account_balance">
          <div className="account_balance_inner">
            <div className="platform">
              <div className="step-section">
                <div
                  className="heading"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    width: "100%",
                    flexWrap: "wrap",
                    gap: "15px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      gap: "4px",
                      width: "100%",
                    }}
                  >
                    <div className="header-and-toggle">
                      <h1
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          margin: 0,
                        }}
                      >
                        Choose your Step
                      </h1>
                      <div
                        className="toggle_container"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <span
                          style={{
                            color: "#adadad",
                            fontFamily: "Montserrat",
                            fontSize: "14px",
                            fontWeight: "500",
                          }}
                        >
                          Show Objectives:
                        </span>
                        <label className="switch">
                          <input
                            type="checkbox"
                            checked={showObjectives}
                            onChange={(e) =>
                              setShowObjectives(e.target.checked)
                            }
                          />
                          <span className="slider round"></span>
                        </label>
                      </div>
                    </div>
                    <p
                      style={{
                        color: "#adadad",
                        fontFamily: "Montserrat",
                        fontSize: "14px",
                        fontWeight: "400",
                        margin: 0,
                        textAlign: "left",
                      }}
                    >
                      Choose your preferred plan and continue through the setup in a few simple steps.
                    </p>
                  </div>
                </div>
                <div className="platform_main">
                  {challenges.map((step, idx) => (
                    <label
                      key={step?.step || step?.step} // Ensure unique key
                      onClick={() => {
                        if (step?.step === "Step 1" || step?.step === 1) {
                          setSelectedPayoutType(2);
                        }
                        setSelectedStep(step);
                        setFinalPrice({});
                      }}
                      className={`platform_box ${selectedStep?.step === step?.step
                        ? "active_label selected_box"
                        : ""
                        }`}
                    >
                      <img
                        src={(() => {
                          // Check if step is "Instant" or "Instant Funding"
                          if (step?.step?.toLowerCase().includes("instant")) {
                            const imgs = stepsImages["Instant Funding"];
                            return selectedStep?.step === step?.step ? imgs?.active : imgs?.normal;
                          }
                          // For numeric steps (Step 1, Step 2, Step 3)
                          const key = Number(step?.step?.replace(/\D/g, ""));
                          const imgs = stepsImages[key];
                          return selectedStep?.step === step?.step ? imgs?.active : imgs?.normal;
                        })()}
                        alt={`Step ${step?.step} Icon`}
                      />
                      <div className="stepdata">
                        <p>{step?.step}</p>
                        <h1>{Number(step?.step?.replace(/\D/g, "")) ? `Standard ${Number(step?.step?.replace(/\D/g, ""))}-phase` : step?.step}</h1>
                      </div>
                    </label>
                  ))}
                </div>
              </div>

              {selectedStep && (
                <div className="user_ac_type">
                  <div className="account_balance_header">
                    <h2>Account Type</h2>
                    <p>
                      Select the trading account that best matches your
                      strategy, goals, and trading style.
                    </p>
                  </div>
                  <div className="user_ac_type_inner">
                    {selectedStep.plans?.map((plan, index) => {
                      return (
                        <div
                          className="ac_type_card_wrapper"
                          key={plan?.plan_type || index}
                        >
                          {plan?.plan_type?.toLowerCase() === "alpha pro" && (
                            <span className="green_discount_badge">Popular</span>
                          )}
                          <label
                            htmlFor={`plan-${index}`}
                            className={`ac_type_option ${plan?.plan_type === selectedPlan?.plan_type
                              ? "active_label"
                              : ""
                              }`}
                            onClick={() => {
                              setSelectedPlan(plan);
                              setFinalPrice({});
                              if (
                                plan?.plan_type.toLowerCase() === "free trial"
                              ) {
                                // For free trial, always use MT5
                                setSelectedPlatform(platformList[0]);
                                setUseEA(false);
                              }
                            }}
                          >
                            <div className="ac_type_header">
                              <div className="label_inner_div">
                                <img
                                  src={
                                    plan?.plan_type === selectedPlan?.plan_type
                                      ? CheckCircle
                                      : BlankCircle
                                  }
                                  alt="radio"
                                />
                                <p>{plan?.plan_type || "Unnamed Plan"}</p>
                                <input
                                  type="radio"
                                  id={`plan-${index}`}
                                  name="fundingEval"
                                  value={plan?.plan_type || ""}
                                  checked={
                                    plan?.plan_type === selectedPlan?.plan_type
                                  }
                                  readOnly
                                  style={{ display: "none" }}
                                />
                              </div>
                            </div>

                            {showObjectives && renderPlanDetails(plan)}
                          </label>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
              {selectedPlan && (
                <div className="accountSize">
                  <div className="account_balance_header">
                    <h2>Account Size</h2>
                    <p>
                      Pick the account balance you want to trade with based on
                      your experience and risk preference.
                    </p>
                  </div>
                  <div className="amount_list">
                    {selectedPlan.challenges?.length > 0 ? (
                      selectedPlan.challenges.map((challenge, index) => {
                        const isSelected =
                          challenge?.id === selectedChallenge?.id;

                        // For Step 2 with On-Demand payout, show ondemand_price
                        const isStep2 = selectedStep?.step === "Step 2" || selectedStep?.step === 2;
                        const isOnDemandPayout = selectedPayoutType === 2;
                        const displayPrice = isStep2 && isOnDemandPayout && challenge?.ondemand_price
                          ? challenge.ondemand_price
                          : challenge?.Price;

                        return (
                          <label
                            htmlFor={`challenge-${challenge?.id || index}`}
                            key={challenge?.id || index}
                            className={`amount_box ${isSelected ? "active_label selected_box" : ""
                              }`}
                            onClick={() => {
                              setFinalPrice({});
                              setSelectedChallenge(challenge);
                              setSelectedChallenge_id(challenge?.id);
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                gap: "5px",
                                width: "100%",
                              }}
                            >
                              <img
                                src={isSelected ? CheckCircle : BlankCircle}
                                alt="radio"
                              />
                              <p>{dollarUS(challenge?.account_balance || 0)}</p>
                              <input
                                type="radio"
                                name="account_balance_value"
                                id={`challenge-${challenge?.id || index}`}
                                checked={isSelected}
                                readOnly
                                style={{ display: "none" }}
                              />
                            </div>
                            <div className="account-blance-info">
                              <div className="amount-value">
                                {dollarUS(displayPrice || 0)}
                              </div>
                              <div className="payment-type">
                                One Time payment
                              </div>
                            </div>
                          </label>
                        );
                      })
                    ) : (
                      <p>No challenges available</p>
                    )}
                  </div>
                </div>
              )}
              <div className="platform">
                <div className="account_balance_header">
                  <h2>Platform</h2>
                  <p>
                    Choose the trading platform you are most comfortable using
                    for execution and analysis.
                  </p>
                </div>
                <div className="platform_main">
                  {platformList
                    ?.filter((platform) => {
                      const is2500Challenge =
                        String(selectedChallenge?.account_balance).trim() === "2500";
                      if (is2500Challenge) {
                        return platform.value === "mt5";
                      }

                      return true; // Otherwise, include all platforms
                    })
                    .map((platform, index) => {
                      const isFreeTrial =
                        selectedPlan?.plan_type?.toLowerCase() === "free trial";
                      const isPlatformDisabledForFreeTrial =
                        isFreeTrial && platform.value !== "mt5";

                      return (
                        <label
                          key={platform?.value || index} // Unique key using value or index
                          htmlFor={`platform-${platform?.value || index}`} // Unique ID
                          className={`platform_box ${platform?.value === selectedPlatform?.value
                            ? "active_label selected_box"
                            : ""
                            } ${isPlatformDisabledForFreeTrial ? "disabled" : ""}`}
                          onClick={() => {
                            if (!isPlatformDisabledForFreeTrial && !platform.disabled) {
                              setSelectedPlatform(platform);
                            }
                          }}
                          style={{
                            cursor: isPlatformDisabledForFreeTrial ? "not-allowed" : (platform.disabled ? "default" : "pointer"),
                            pointerEvents: platform.disabled ? "none" : "auto",
                            border: platform?.disabled
                              ? "1.5px solid transparent"
                              : "1.423px solid #141414",
                            borderRadius: "5px",
                            background: platform?.disabled
                              ? `linear-gradient(rgba(0, 0, 0, 1), rgba(0, 0, 0, 1)) padding-box, 
       linear-gradient(to right, rgba(200, 50, 40, 1), rgba(251, 136, 65, 1), rgba(211, 221, 146, 1), rgba(89, 130, 79, 1), rgba(153, 194, 255, 1)) border-box`
                              : "#121212",
                          }}
                        >
                          <img
                            src={
                              platform.disabled
                                ? AlphaTraderIcon
                                : platformIcons[platform?.value] || ""
                            }
                            alt={`${platform?.name || "platform"} logo`}
                          />
                          <p style={{ color: platform?.disabled && "#fff" }}>
                            {platform?.name || "Unnamed Platform"}
                          </p>
                          <input
                            type="radio"
                            name="platform_type"
                            id={`platform-${platform?.value || index}`}
                            checked={platform?.value === selectedPlatform?.value}
                            style={{
                              display: "none",
                              pointerEvents: platform.disabled ? "none" : "auto",
                            }}
                            onChange={() => { }}
                          />
                          {platform.disabled && (
                            <div className="is-comming">Coming Soon</div>
                          )}
                        </label>
                      );
                    })}
                </div>
              </div>
              <div className="confirm_order">
                <div className="account_balance_header">
                  <h2>Payment Method</h2>
                  <p>
                    Complete your purchase securely using your preferred payment
                    option.
                  </p>
                </div>
                <div className="order_option">
                  <div
                    className="paymentMethodSelectorBox"
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: "15px",
                      width: "100%",
                    }}
                  >
                    {paymentMethods
                      .filter(
                        (method) =>
                          method.value !== "payok" ||
                          PAYOK_ALLOWED_COUNTRIES.includes(
                            basicDetails.Country?.toLowerCase(),
                          ),
                      )
                      .map((method) => (
                      <div
                        key={method.value}
                        id={method.value}
                        onClick={() => handlePaymentMethod(method.value)}
                        className={`payment-option ${selectedPaymentMethod === method.value ? "active" : ""
                          } ${method.value !== "coinspayment" ? "nuvei" : ""}`}
                        style={{
                          width: "100%",
                          display: "flex",
                          alignItems: "center",
                          flexDirection: "column",
                        }}
                      >
                        <label
                          htmlFor={`${method.value}-radio`}
                          className={`payment-label ${selectedPaymentMethod === method.value
                            ? "payments-active_new active_label"
                            : ""
                            }`}
                        >
                          <div
                            className={`icon-box ${selectedPaymentMethod === method.value
                              ? "active_icon"
                              : ""
                              }`}
                          >
                            <img
                              src={paymentMethodDetails[method.value]?.icon}
                              style={{ height: "23px", width: "23px" }}
                              alt={method.name}
                              className="payment-logo"
                            />
                          </div>
                          <div className="payment-logo-container">
                            {/* <img
                              src={
                                selectedPaymentMethod === method.value
                                  ? radioActiveBtn
                                  : radioBtn
                              }
                              alt="radio"
                            /> */}
                            <input
                              type="radio"
                              id={`${method.value}-radio`}
                              name="payment_method"
                              checked={selectedPaymentMethod === method.value}
                              onChange={() => handlePaymentMethod(method.value)}
                              style={{ display: "none" }}
                            />
                            <p>{method.name}</p>
                          </div>
                          {/* <img
                            src={paymentMethodDetails[method.value]?.icon}
                            style={{ height: "23px", width: "23px" }}
                            alt={method.name}
                            className="payment-logo"
                          /> */}
                        </label>
                        {paymentMethodDetails[method.value]?.supported.length >
                          0 && (
                            <div className="combined_payments">
                              {paymentMethodDetails[method.value].supported.map(
                                (icon, idx) => (
                                  <img
                                    key={idx}
                                    src={icon}
                                    alt={`${method.name} supported method`}
                                    style={
                                      icon === googlepay
                                        ? { width: "30px" }
                                        : undefined
                                    }
                                  />
                                ),
                              )}
                            </div>
                          )}
                      </div>
                    ))}
                  </div>
                </div>
                {(selectedPlan?.plan_type?.toLowerCase().includes("alpha pro") ||
                  selectedPlan?.plan_type?.toLowerCase().includes("alpha three")) && (
                    <PayoutTypeSelector
                      payout_type={payout_type}
                      selectedPayoutType={selectedPayoutType}
                      setSelectedPayoutType={setSelectedPayoutType}
                      showObjectives={showObjectives}
                    />
                  )}

                <div className="commission_EA_use">
                  <div className="commission">
                    <div className="account_balance_header">
                      <h2>Spread</h2>
                    </div>
                    <div className="commission_inner">
                      {ac_type?.map((type, index) => {
                        const isSwapFreeSelected = selectedAddons.includes("swap_free");
                        const isRawSpread = index === 0;
                        const isDisabled = isSwapFreeSelected && isRawSpread;

                        return (
                          <label
                            key={index}
                            htmlFor={`ac-type-${index}`}
                            onClick={() => !isDisabled && setSelectedAcType(index)}
                            className={`platform_box ${selectedAcType === index
                              ? "active_label selected_box"
                              : ""
                              } ${isDisabled ? "disabled" : ""}`}
                          >
                            <img
                              src={
                                selectedAcType === index
                                  ? CheckCircle
                                  : BlankCircle
                              }
                              alt="radio"
                            />
                            <p>{type || "Unnamed Type"}</p>
                            <input
                              type="radio"
                              name="commission_type"
                              id={`ac-type-${index}`}
                              checked={selectedAcType === index}
                              onChange={() => !isDisabled && setSelectedAcType(index)}
                              disabled={isDisabled}
                              style={{ display: "none" }}
                            />
                          </label>
                        );
                      })}
                    </div>
                  </div>

                  {(() => {
                    const isInstantQualifiedAlphaDirect =
                      selectedStep?.step === "Instant Qualified" &&
                      selectedPlan?.plan_type === "Alpha Direct";

                    const shouldShowEA =
                      selectedPlatform?.value === "mt5";

                    // Check if EA should be disabled
                    const isSwapFreeSelected = selectedAddons.includes("swap_free");
                    const isFreeTrial = selectedPlan?.plan_type?.toLowerCase() === "free trial";
                    const isEADisabled = isInstantQualifiedAlphaDirect || isSwapFreeSelected || isFreeTrial;

                    return (
                      shouldShowEA && (
                        <div className="EA_use">

                          <div className="account_balance_header">
                            <h2>EA Use</h2>
                          </div>
                          <div className="EA_use_inner">
                            <label
                              htmlFor="ea-yes"
                              onClick={() => !isEADisabled && setUseEA(true)}
                              className={`platform_box ${useEA ? "active_label selected_box" : ""} ${isEADisabled ? "disabled" : ""}`}
                            >
                              <img src={useEA ? CheckCircle : BlankCircle} alt="radio" />
                              <p>Yes</p>
                              <input
                                type="radio"
                                name="ea_use"
                                id="ea-yes"
                                checked={useEA}
                                onChange={() => !isEADisabled && setUseEA(true)}
                                disabled={isEADisabled}
                                style={{ display: "none" }}
                              />
                            </label>

                            <label
                              htmlFor="ea-no"
                              onClick={() => !isEADisabled && setUseEA(false)}
                              className={`platform_box ${!useEA ? "active_label selected_box" : ""} ${isEADisabled ? "disabled" : ""}`}
                            >
                              <img src={!useEA ? CheckCircle : BlankCircle} alt="radio" />
                              <p>No</p>
                              <input
                                type="radio"
                                name="ea_use"
                                id="ea-no"
                                checked={!useEA}
                                onChange={() => !isEADisabled && setUseEA(false)}
                                disabled={isEADisabled}
                                style={{ display: "none" }}
                              />
                            </label>
                          </div>
                        </div>
                      )
                    );
                  })()}

                </div>

                {/* Add-ons Section */}
                {(() => {
                  const visibleAddons = (showProfitSplit
                    ? addonsList
                    : addonsList.filter((addon) => addon.value !== "90")
                  ).filter(
                    (addon) =>
                      addon.value !== "swap_free" ||
                      (selectedPlatform?.value === "mt5" &&
                        selectedPlan?.plan_type?.toLowerCase() !== "swing" &&
                        selectedPlan?.plan_type?.toLowerCase() !== "alpha direct")
                  );

                  if (selectedPlan?.plan_type?.toLowerCase() === "free trial") {
                    return null;
                  }

                  if (
                    selectedPlan?.plan_type?.toLowerCase() === "alpha direct" ||
                    visibleAddons.length === 0
                  ) {
                    return null;
                  }

                  // Compute the extra cost for a given addon, based on the currently selected challenge
                  const getAddonPriceDiff = (addonValue) => {
                    if (!selectedChallenge) return null;

                    const basePrice = parseFloat(selectedChallenge.ondemand_price || 0);

                    if (addonValue === "90") {
                      const ninetyPrice = parseFloat(selectedChallenge.ninty_pfs_price || 0);
                      return Math.ceil(ninetyPrice - basePrice);
                    }

                    if (addonValue === "swap_free") {
                      const swapPrice =
                        selectedProfitSplit === 90
                          ? parseFloat(selectedChallenge.swap_free_price_ninty || 0)
                          : parseFloat(selectedChallenge.swap_free_price_eighty || 0);
                      return Math.ceil(swapPrice - basePrice);
                    }

                    return null;
                  };

                  return (
                    <div className="platform addons-section" style={{}}>
                      <div className="account_balance_header">
                        <h2>Add-ons</h2>
                      </div>
                      <div className="platform_main">
                        {visibleAddons.map((addon) => {
                          const isSelected =
                            addon.value === "90"
                              ? selectedProfitSplit === Number(addon.value)
                              : selectedAddons.includes(addon.value);

                          const priceDiff = getAddonPriceDiff(addon.value);

                          // Disable swap_free when EA is selected as "Yes"
                          const isSwapFreeDisabled = addon.value === "swap_free" && useEA;

                          return (
                            <label
                              key={addon.value}
                              onClick={() => !isSwapFreeDisabled && handleAddonToggle(addon.value)}
                              className={`platform_box ${isSelected ? "active_label selected_box" : ""} ${isSwapFreeDisabled ? "disabled" : ""}`}
                            >
                              <img
                                src={isSelected ? CheckCircle : BlankCircle}
                                alt="checkbox"
                              />
                              <p>
                                {addon.name}
                                {priceDiff !== null && !isNaN(priceDiff) && (
                                  <span> (+{dollarUS(priceDiff)})</span>
                                )}
                              </p>
                            </label>
                          );
                        })}
                      </div>
                    </div>
                  );
                })()}

                {showTnc && (
                  <TncModal open={showTnc} onClose={() => setShowTnc(false)} />
                )}
                <TncModal open={showTnc} onClose={() => setShowTnc(false)} />

                <CustomerInfoForm
                  publicCheckout={publicCheckout}
                  basicDetails={basicDetails}
                  setBasicDetails={setBasicDetails}
                  basicDetailsDisabled={basicDetailsDisabled}
                  checkValidate={checkValidate}
                  allErrors={allErrors}
                />
              </div>
            </div>
            <div
              className="termsCondition"
              style={{ width: "100%", height: "100%" }}
            >
              <p>Terms and Conditions</p>
              <div className="zoomBtn" onClick={() => setShowTnc(!showTnc)}>
                <button>
                  <img src={zoomImg} alt="Zoom" />
                </button>
              </div>
              <div className="termWrapper">
                <PDFPreview
                  fileUrl={PDFDoc}
                  style={{ height: "400px" }}
                  defaultScale={scale}
                />
              </div>
            </div>
          </div>
          <div className="help-section">
            <div className="help-left">
              <div className="help-icon-box">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="22"
                  viewBox="0 0 24 22"
                  fill="none"
                >
                  <path
                    d="M22.9733 9.6953H22.4765C22.2447 7.22086 21.1849 4.91513 19.4407 3.13804C17.4535 1.1135 14.804 0 11.989 0C6.52438 0 2.02024 4.26278 1.51242 9.6953H1.01564C0.452622 9.6953 0 10.1564 0 10.7301V17.1861C0 17.7597 0.452622 18.2209 1.01564 18.2209H3.02484V19.4356V19.5481C3.02484 20.8977 4.10672 22 5.43146 22H12V19.7505H5.42042C5.31003 19.7505 5.22171 19.6605 5.22171 19.5481V19.4356V16.4663V8.48057H3.97424C4.94572 4.89264 8.16927 2.24949 11.989 2.24949C14.2079 2.24949 16.3054 3.12679 17.873 4.73517C18.9108 5.79243 19.6283 7.07464 20.0037 8.48057H18.7673V19.4356H20.9752V18.2209H22.9844C23.5474 18.2209 24 17.7597 24 17.1861V10.7301C23.989 10.1564 23.5363 9.6953 22.9733 9.6953ZM2.02024 11.7648H3.0138V16.1626H2.02024V11.7648ZM21.9577 16.1513H20.9752V11.7536H21.9687V16.1513H21.9577Z"
                    fill="#5B5B5B"
                  />
                </svg>
              </div>
              <div className="help-text">
                <h3>Need some help?</h3>
                <p>We are here for you, Write us a message</p>
              </div>
            </div>
            <button
              className="help-chat-btn"
              onClick={() => {
                if (window.Tawk_API && window.Tawk_API.maximize) {
                  window.Tawk_API.maximize();
                } else if (
                  window.LiveChatWidget &&
                  window.LiveChatWidget.call
                ) {
                  window.LiveChatWidget.call("show");
                } else if (window.Intercom) {
                  window.Intercom("show");
                } else {
                  const chatLauncher = document.querySelector(
                    ".livechat-launcher, #chat-widget-launcher, #hubspot-messages-iframe-container",
                  );
                  if (chatLauncher) {
                    chatLauncher.click();
                  } else {
                    window.open(
                      "mailto:support@alphacapitalgroup.com",
                      "_blank",
                    );
                  }
                }
              }}
            >
              Chat with us
            </button>
          </div>
        </div>
        <CustomerInformation
          selectedStep={selectedStep}
          selectedPlan={selectedPlan}
          selectedChallenge={selectedChallenge}
          selectedPlatform={selectedPlatform}
          selectedPayoutType={selectedPayoutType}
          coupon={coupon}
          setCoupon={setCoupon}
          finalPrice={finalPrice}
          setFinalPrice={setFinalPrice}
          validateCouponCode={handleCouponClick}
          removeCoupon={false}
          isChecked={isChecked}
          setIsChecked={setIsChecked}
          setShowTNC={setShowTnc}
          handleNavigationLinks={(url) => window.open(url, "_blank")}
          countryCheck={countryCheck}
          confirmPaymentClick={confirmPaymentClick}
          handleFinalPayment={accountPreview} //handleFinalCheckout
          dollarUS={dollarUS}
          isCheckedError={isCheckedError}
          setIsCheckedError={setIsCheckedError}
          isCouponLoading={isCouponLoading}
          setShowTnc={setShowTnc}
          selectedProfitSplit={selectedProfitSplit}
          showProfitSplit={showProfitSplit}
        />{" "}
      </div>
    </div>
  );
};

export default UpdatedNewCheckoutPage;
